import { SVGProps, Ref, forwardRef } from 'react';

export const CompanysLifeFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 9c0-6 2-8 8-8h8c6 0 8 2 8 8 0 5.69-1.81 7.78-7.13 7.98L12 23l-4.87-6.02C1.81 16.79 0 15 0 9m12 3.1c-.616 0-1.6-.34-1.6-1.1H8.6c0 .71.295 1.339.744 1.816.644.686 1.617 1.084 2.656 1.084s2.012-.398 2.656-1.084c.448-.477.744-1.106.744-1.816h-1.8c0 .76-.984 1.1-1.6 1.1m1.75-5.35c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75M8.5 5c-1.312 0-1.75.875-1.75 1.75S7.188 8.5 8.5 8.5s1.75-.875 1.75-1.75S9.813 5 8.5 5"
                fill="currentColor"
            />
        </g>
    </svg>
));
CompanysLifeFilledSize24Glyph.displayName = 'CompanysLifeFilledSize24Glyph';
